export const LOGISTIC_RADIO_TRANSITION = 'all 0.4s ease-in-out';
export const STORE_IN_VAULT_INPUT_ID = 'storeInVault';
export const TRANSITION_DELAY = 400; // 0.4s
